// Inventário de rastreadores via /api/admin/trackers/*. Só verified_organizer
// (backend gateado pela policy `RequireVerifiedOrganizer`; o AuthGuard da rota
// é defesa em profundidade).

import { api } from './client';

export type TrackerStatus = 'active' | 'inactive';

export interface TrackerModel {
  id: string;
  manufacturer: string;
  model: string;
}

export interface Tracker {
  id: string;
  trackerModelId: string;
  manufacturer: string;
  model: string;
  imei: string;
  serialNumber: string;
  /// ICCID do chip; null = sem chip cadastrado.
  iccid: string | null;
  /// `yyyy-MM-dd` (data de calendário, sem fuso).
  purchaseDate: string;
  status: TrackerStatus;
  createdAt: string;
  updatedAt: string;
}

export interface TrackerPage {
  items: Tracker[];
  total: number;
  page: number;
  pageSize: number;
}

export interface TrackerUpsert {
  trackerModelId: string;
  imei: string;
  serialNumber: string;
  /// Vazio = sem chip (o backend grava null).
  iccid: string;
  purchaseDate: string;
}

export const trackersApi = {
  models: (): Promise<TrackerModel[]> => api<TrackerModel[]>('/api/admin/tracker-models'),

  /// `query` vem do `listQuery` (lib/trackers).
  list: (query: string): Promise<TrackerPage> => api<TrackerPage>(`/api/admin/trackers?${query}`),

  create: (body: TrackerUpsert): Promise<Tracker> =>
    api<Tracker>('/api/admin/trackers', { method: 'POST', body }),

  update: (id: string, body: TrackerUpsert): Promise<Tracker> =>
    api<Tracker>(`/api/admin/trackers/${encodeURIComponent(id)}`, { method: 'PUT', body }),

  /// Exclusão é lógica: inativar, nunca apagar.
  setStatus: (id: string, status: TrackerStatus): Promise<Tracker> =>
    api<Tracker>(`/api/admin/trackers/${encodeURIComponent(id)}/status`, {
      method: 'PATCH',
      body: { status },
    }),
};
